(function () {
    window.NewsGraph = window.NewsGraph || {};

    window.NewsGraph.runForce = function(nodes, links, meshMap) {
        const THREE  = window.THREE;

        const pos = {};
        const nodeTypeMap = {};
        nodes.forEach(n => {
            pos[n.id] = meshMap[n.id].object3D.position.clone();
            nodeTypeMap[n.id] = n.type;
        });

        const REPULSION = 8.0;
        const LINK_K    = 0.07;
        const CENTER_K  = 0.012;
        const ITERS     = 100;

        const degreeMap = {};
        nodes.forEach(n => { degreeMap[n.id] = 0; });
        links.forEach(l => {
            if (degreeMap[l.source] !== undefined) degreeMap[l.source]++;
            if (degreeMap[l.target] !== undefined) degreeMap[l.target]++;
        });
        const maxDeg = Math.max(1, ...Object.values(degreeMap));

        const counts  = nodes.map(n => n.article_count || 0);
        const minCnt  = Math.min(...counts);
        const maxCnt  = Math.max(...counts);
        const normSize = {};
        nodes.forEach(n => {
            normSize[n.id] = maxCnt > minCnt
                ? ((n.article_count || 0) - minCnt) / (maxCnt - minCnt)
                : 0.5;
        });

        const getRadius = (id) => (meshMap[id] && meshMap[id].userData && meshMap[id].userData.radius) || 0.1;
        const PADDING = 1.0;

        for (let iter = 0; iter < ITERS; iter++) {
            const alpha   = 1 - iter / ITERS;
            const forces  = {};
            nodes.forEach(n => { forces[n.id] = new THREE.Vector3(); });

            for (let i = 0; i < nodes.length; i++) {
                for (let j = i + 1; j < nodes.length; j++) {
                    const a    = nodes[i].id;
                    const b    = nodes[j].id;
                    const diff = pos[a].clone().sub(pos[b]);
                    const d    = diff.length();
                    
                    const minAllowed = getRadius(a) + getRadius(b) + PADDING;

                    if (d > 0.001) {
                        if (d < minAllowed) {
                            const fv = diff.normalize().multiplyScalar((minAllowed - d) * 0.5);
                            forces[a].add(fv);
                            forces[b].sub(fv);
                        } else {
                            const fv = diff.normalize().multiplyScalar(REPULSION / (d * d));
                            forces[a].add(fv);
                            forces[b].sub(fv);
                        }
                    } else {
                        const fv = new THREE.Vector3(Math.random() - 0.5, Math.random() - 0.5, Math.random() - 0.5).normalize().multiplyScalar(0.1);
                        forces[a].add(fv);
                        forces[b].sub(fv);
                    }
                }
            }

            links.forEach(link => {
                const p1 = pos[link.source];
                const p2 = pos[link.target];
                if (!p1 || !p2) return;

                const NARRATIVE_TYPES = window.NewsGraph.NARRATIVE_TYPES;
                const sourceIsNarrative = NARRATIVE_TYPES.has(nodeTypeMap[link.source]);
                const targetIsNarrative = NARRATIVE_TYPES.has(nodeTypeMap[link.target]);
                const isNarrativeTickerLink = (sourceIsNarrative !== targetIsNarrative);

                const minAllowed = getRadius(link.source) + getRadius(link.target) + PADDING;
                
                let ideal = minAllowed + (1 - link.strength / 100) * 1.5;
                if (isNarrativeTickerLink) {
                    ideal = Math.max(ideal, minAllowed + 2.5);
                }

                const diff  = p2.clone().sub(p1);
                const len   = diff.length();
                if (len > 0.001) {
                    const delta = (len - ideal) * LINK_K;
                    const fv    = diff.normalize().multiplyScalar(delta);
                    forces[link.source].add(fv);
                    forces[link.target].sub(fv);
                }
            });

            nodes.forEach(n => {
                const isNarrative = window.NewsGraph.NARRATIVE_TYPES.has(n.type);
                const degNorm  = (degreeMap[n.id] || 0) / maxDeg;
                const weight   = 1 + degNorm * 1.5 + normSize[n.id] * 1.0;

                if (isNarrative) {
                    const hasConnections = (degreeMap[n.id] || 0) > 0;
                    const gravityMultiplier = hasConnections ? 1.0 : 3.0;
                    forces[n.id].addScaledVector(pos[n.id], -CENTER_K * weight * gravityMultiplier);
                } else {
                    const d = pos[n.id].length();
                    const hasConnections = (degreeMap[n.id] || 0) > 0;
                    if (!hasConnections) {
                        forces[n.id].addScaledVector(pos[n.id], -CENTER_K * weight * 1.8);
                    } else {
                        const R_orbit = 3.6;
                        if (d > 0.01) {
                            const factor = (d - R_orbit) / d;
                            forces[n.id].addScaledVector(pos[n.id], -CENTER_K * weight * factor);
                        } else {
                            forces[n.id].add(new THREE.Vector3(Math.random() - 0.5, Math.random() - 0.5, Math.random() - 0.5).normalize().multiplyScalar(0.1));
                        }
                    }
                }
            });

            nodes.forEach(n => {
                pos[n.id].addScaledVector(forces[n.id], alpha);
            });
        }


        const NARRATIVE_TYPES = window.NewsGraph.NARRATIVE_TYPES;

        const narNodes = [];
        const tkrNodes = [];
        nodes.forEach(n => {
            if (NARRATIVE_TYPES.has(n.type)) narNodes.push(n);
            else tkrNodes.push(n);
        });

        const allRadii = nodes.map(n => pos[n.id].length()).sort((a, b) => a - b);

        const narPool = allRadii.slice(0, narNodes.length);
        const tkrPool = allRadii.slice(narNodes.length);

        narNodes.sort((a, b) => pos[a.id].length() - pos[b.id].length());
        tkrNodes.sort((a, b) => pos[a.id].length() - pos[b.id].length());

        narNodes.forEach((n, i) => {
            const p = pos[n.id];
            if (p.length() > 0.001) {
                p.normalize().multiplyScalar(narPool[i]);
            }
        });

        let maxNarBoundary = 0;
        narNodes.forEach((n, i) => {
            const nodeRadius = getRadius(n.id);
            const dist = narPool[i];
            const boundary = dist + nodeRadius;
            if (boundary > maxNarBoundary) {
                maxNarBoundary = boundary;
            }
        });

        const SEPARATION_R = maxNarBoundary + 0.15;

        tkrNodes.forEach((n, i) => {
            const p = pos[n.id];
            if (p.length() > 0.001) {
                const nodeRadius = getRadius(n.id);
                const minDist = SEPARATION_R + nodeRadius + 0.3;
                const finalDist = Math.max(tkrPool[i], minDist);
                p.normalize().multiplyScalar(finalDist);
            }
        });

        for (let relaxIter = 0; relaxIter < 5; relaxIter++) {
            for (let i = 0; i < nodes.length; i++) {
                for (let j = i + 1; j < nodes.length; j++) {
                    const a = nodes[i].id;
                    const b = nodes[j].id;
                    
                    const minAllowed = getRadius(a) + getRadius(b) + PADDING;
                    const pA = pos[a];
                    const pB = pos[b];
                    const diff = pA.clone().sub(pB);
                    const d = diff.length();

                    if (d > 0.0001 && d < minAllowed) {
                        const overlap = minAllowed - d;
                        const push = diff.normalize().multiplyScalar(overlap * 0.5);
                        pA.add(push);
                        pB.sub(push);
                    }
                }
            }
        }

        // Write final positions
        nodes.forEach(n => {
            meshMap[n.id].object3D.position.copy(pos[n.id]);
        });

        return SEPARATION_R;
    };
})();
